import { create } from 'zustand';
import { supabase } from '../lib/supabase';
import { toast } from 'react-hot-toast';
import { AuthError } from '@supabase/supabase-js';

interface AuthState {
  isAuthenticated: boolean;
  loading: boolean;
  error: string | null;
  login: () => Promise<void>;
  logout: () => Promise<void>;
}

export const useAuth = create<AuthState>((set) => ({
  isAuthenticated: false,
  loading: false,
  error: null,
  login: async () => {
    set({ loading: true });
    try {
      const email = prompt('Email administrateur:', 'admin@novster.fr');
      if (!email) {
        throw new Error('L\'email est requis');
      }
      
      const password = prompt('Mot de passe:');
      if (!password) {
        throw new Error('Le mot de passe est requis');
      }

      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (error) {
        throw error;
      }

      if (!data.user || !data.session) {
        throw new Error('Échec de l\'authentification');
      }

      set({ isAuthenticated: true, error: null });
      toast.success('Connecté avec succès');
    } catch (error) {
      let errorMessage = 'Erreur de connexion';
      if (error instanceof AuthError) {
        switch (error.message) {
          case 'Invalid login credentials':
            errorMessage = 'Identifiants invalides. Utilisez admin@novster.fr / novster2024';
            break;
          case 'Email not confirmed':
            errorMessage = 'Email non confirmé';
            break;
          case 'Invalid email':
            errorMessage = 'Format d\'email invalide';
            break;
          default:
            errorMessage = 'Erreur de connexion: ' + error.message;
        }
      }
      if (error instanceof Error) {
        errorMessage = error.message;
      }
      toast.error(errorMessage);
      set({ error: errorMessage, isAuthenticated: false });
    } finally {
      set({ loading: false });
    }
  },
  logout: async () => {
    try {
      await supabase.auth.signOut();
      set({ isAuthenticated: false, error: null });
      toast.success('Déconnecté avec succès');
    } catch (error) {
      toast.error('Erreur lors de la déconnexion');
      set({ error: 'Erreur lors de la déconnexion' });
    }
  },
}));